var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifier = function SvgMagnifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#979797",
    d: "m23.727 22.166-5.858-5.794a9.88 9.88 0 0 0 2.333-6.379c0-5.51-4.531-9.993-10.1-9.993C4.531 0 0 4.483 0 9.993s4.531 9.992 10.101 9.992c2.45 0 4.698-.867 6.449-2.307l5.857 5.794a.938.938 0 0 0 1.32 0 .917.917 0 0 0 0-1.306M1.867 9.993c0-4.492 3.693-8.147 8.234-8.147s8.235 3.655 8.235 8.147-3.694 8.146-8.235 8.146-8.235-3.654-8.235-8.146z"
  })));
};
export default SvgMagnifier;